import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from '../../../../../common/services/api'
import { showToast } from '../../../../../common/utils'
import {
  COMMUNICATION_RECORDS_URL,
  COMMUNICATION_RECORDS_QUERY_KEY
} from './useCommunicationRecordCreate'

type UseCommunicationRecordDeleteProps = {
  onSuccess?: () => void
}

type UseCommunicationRecordDeleteReturn = {
  deleteCommunicationRecord: (recordId: string) => Promise<unknown>
  isDeleteLoading: boolean
}

export const useCommunicationRecordDelete = ({
  onSuccess
}: UseCommunicationRecordDeleteProps = {}): UseCommunicationRecordDeleteReturn => {
  const queryClient = useQueryClient()

  const handleError = (err: any) => {
    showToast({
      title: (err?.message || err?.msg || 'Something went wrong') as string,
      type: 'error'
    })
  }

  const handleSuccess = () => {
    showToast({
      title: 'Deleted Communication Record',
      type: 'success'
    })
  }

  const deleteFunction = async (recordId: string) => {
    return postJSON({
      url: `${COMMUNICATION_RECORDS_URL}/${recordId}`,
      method: 'DELETE'
    })
  }

  const { mutateAsync: deleteMutation, isLoading: isDeleteLoading } =
    useMutation<unknown, unknown, string, unknown>(
      [COMMUNICATION_RECORDS_QUERY_KEY, 'delete'],
      deleteFunction,
      {
        onSuccess: () => {
          handleSuccess()
          queryClient.invalidateQueries([COMMUNICATION_RECORDS_QUERY_KEY])
          onSuccess?.()
        },
        onError: (err) => handleError(err)
      }
    )

  const deleteCommunicationRecord = async (recordId: string) => {
    try {
      const result = await deleteMutation(recordId)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    deleteCommunicationRecord,
    isDeleteLoading
  }
}
